import {Head, router} from '@inertiajs/react'
import Layout from "../../components/layout";
import {useCallback, useState} from "react";
import toast from "react-hot-toast";

export default function Join({event}) {
    const [loading, setLoading] = useState(false);
    const onContinueClick = useCallback(async () => {
        if (loading){
            return;
        }
        setLoading(true);
        try {
            const response = await axios.post(`/camera/events/${event.id}/participate`);
            if (response.data.success){
                toast.success('Successfully joined the event!');
                router.reload();
            }
        } catch (e){
            if (e.response && e.response.data && e.response.data.message){
                toast.error(e.response.data.message);
            }
        } finally {
            setLoading(false);
        }

    }, []);

    return (
        <Layout>
            <Head title={event.name}/>
            <div className="relative h-full">
                <img className="absolute object-cover inset-0 w-full h-full -z-10" src={event.thumbnail_url} alt=""/>
                <div className="flex h-full flex-col flex-grow bg-gradient-to-b from-transparent via-transparent to-black full-screen">
                    <div className="flex flex-grow"></div>
                    <div className="flex flex-col px-[20px] pb-[20px]">
                        <h1 className="text-white text-[40px] font-bold">{event.name}</h1>
                        <p className="text-white">{event.organizer.name}</p>
                        <button
                            disabled={loading}
                            className="flex-wrap shadow transition duration-300 transform px-6 py-3 font-medium text-white mt-[10px] rounded-[10px] focus:outline-none hover:shadow-md bg-primary-500 hover:bg-primary-500/80 focus:bg-primary-500/80 text-center"
                                onClick={onContinueClick}>Join</button>
                    </div>
                </div>
            </div>
        </Layout>
    )
}
